<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>账号管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateAccountDialog"
          > + 建立新账号
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      ref="dataTable"
      :headers="headers"
      :items="accounts"
      :items-per-page="5"
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions
      }"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          :color="getStatusColor(item.accountStatus.name)"
          small
        >
          {{ item.accountStatus.name }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small class="mr-2" @click="showEditAccountDialog(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn text small color="red" @click="showDeleteConfirmation(item)">
          停用
          <!-- <v-icon small>mdi-delete</v-icon> -->
        </v-btn>
      </template>
    </v-data-table>

    <create-account-popup
    ref="createAccountPopup"
    @refresh-list="refreshList">

    </create-account-popup>
    <edit-account-popup
      ref="editAccountPopup"
      :item="selectedAccount"
      @refresh-list="refreshList"
    ></edit-account-popup>
    <disable-account-confirmation
      ref="disableAccountConfirmation"
      :item="selectedAccount"
      @refresh-list="refreshList"
    ></disable-account-confirmation>
  </v-container>
</template>

<script>
import CreateAccountPopup from "../components/CreateAccountPopup.vue";
import EditAccountPopup from "../components/EditAccountPopup.vue";
import DisableAccountConfirmation from "../components/DisableAccountConfirmation.vue";
import { userApi } from '@/api/user'

export default {
  components: {
    CreateAccountPopup,
    EditAccountPopup,
    DisableAccountConfirmation,
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "id", value: "id" },
        { text: "用户名", value: "username" },
        { text: "Email", value: "email" },
        { text: "状态", value: "status" },
        { text: "最后登入时间", value: "lastLoginTime" },
        { text: "过期时间", value: "expiredTime" },
        { text: "启用时间", value: "startTime" },
        { text: "操作", value: "actions", sortable: false },
      ],
      accounts: [],
      selectedAccount: {},
      itemsPerPageOptions: [10,30,50,100],
    };
  },

  async created() {
    await this.fetchAccounts()
  },

  methods: {
    // 获取账号列表
    async fetchAccounts() {
      this.loading = true
      try {
        const response = await userApi.getJobSeekerAccounts()
        this.accounts = response.data.jobSeekerAccounts
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取账号列表失败：' + errorMessage)
      } finally {
        this.loading = false
      }
    },

    // 获取状态颜色
    getStatusColor(status) {
      switch (status) {
        case '启用':
          return 'success'
        case '禁用':
          return 'error'
        default:
          return 'grey'
      }
    },

    // 创建账号后刷新列表
    async refreshList() {
      await this.fetchAccounts()
      // this.$toast.success('账号创建成功')
    },

    showCreateAccountDialog() {
      this.$refs.createAccountPopup.dialog = true;
    },
    showEditAccountDialog(item) {
      this.selectedAccount = { ...item };
      this.$refs.editAccountPopup.dialog = true;
    },
    showDeleteConfirmation(item) {
      this.selectedAccount = { ...item };
      this.$refs.disableAccountConfirmation.dialog = true;
    },
  },
};
</script>